import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Carousel } from 'react-bootstrap';
import ConsultantForm from './ConsultantForm';
import EmployerSignupPanel from './EmployerSignupPanel';
import { analyticsTrack } from '../../analyticsUtils';
import './Registration.scss';
var consultantTestimonials = function consultantTestimonials() {
  var donna = {
    name: 'Donna S.',
    title: 'Global Clinical Project Manager, QA/QC',
    body: 'One of the things that I find remarkable about ' + 'Clora is the wide range of projects that are available. ' + 'As a QA auditor and Project Manager, I regularly come ' + 'across projects that interest me on the platform [...] ' + 'the clients have been really wonderful to work with.'
  };
  var sergey = {
    name: 'Sergey I.',
    title: 'Data Manager',
    body: 'Working with Clora is such a pleasure! ' + 'From the on-boarding process to ongoing interactions ' + 'everyone has been professional and helpful. ' + 'This model and platform is the future of contracting ' + 'in our industry.'
  };
  var angel = {
    name: 'Angel K.',
    title: 'Clinical Project Manager',
    body: 'Clora helped me to match my skills and ' + 'interests to a company\'s needs [...]. In ' + 'over 6 years of consulting, Clora has been ' + 'the smoothest process to match my expertise ' + 'to a contract opportunity. It has been a pleasure ' + 'working with the entire Clora team.'
  };
  var niti = {
    name: 'Niti G.',
    title: 'Clinical Development Consultant',
    body: 'I deeply appreciate my relationship with Clora ' + 'and their professionalism. They value and support ' + 'me through every step of the process and demonstrate ' + 'a clear commitment to matching the right projects with ' + 'the right consultants.'
  };
  var dorothy = {
    name: 'Dorothy F.',
    title: 'Medical Writer, Preclinical & Pharmacology Consultant',
    body: 'I began my consulting business [...] after years ' + 'of fulltime employment [...]. I was very pleased with ' + 'how quickly I matched with contract opportunities ' + 'that were ideally suited for my expertise. ' + 'The Clora team has done a wonderful job of seamlessly ' + 'integrating my consulting role with their customers.'
  };
  return [donna, sergey, angel, niti, dorothy];
};
var renderConsultantTestimonials = function renderConsultantTestimonials() {
  var testimonials = consultantTestimonials();
  return /*#__PURE__*/React.createElement("div", {
    className: "consultant-testimonial-carousel"
  }, /*#__PURE__*/React.createElement(Carousel, {
    controls: false,
    interval: 12500,
    touch: true
  }, testimonials.map(function (testimony) {
    return /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "consultant-testimonial-blurb"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "quote-symbol"
    }, " \u201C "), /*#__PURE__*/React.createElement("p", {
      className: "testimonial-text"
    }, testimony.body)), /*#__PURE__*/React.createElement("div", {
      className: "triangle"
    }), /*#__PURE__*/React.createElement("div", {
      className: "consultant-testimonial-byline"
    }, /*#__PURE__*/React.createElement("div", {
      className: "consultant-name body-text-2"
    }, testimony.name), /*#__PURE__*/React.createElement("div", {
      className: "consultant-title body-text-2"
    }, testimony.title)));
  })));
};
var renderCopy = function renderCopy() {
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h1", {
    className: "hero-header registration-welcome-title"
  }, "Stop searching."), /*#__PURE__*/React.createElement("h1", {
    className: "hero-header registration-welcome-title"
  }, "Start working."));
};
var consultantTestimonialsPanel = function consultantTestimonialsPanel() {
  return /*#__PURE__*/React.createElement("div", {
    className: "right-panel d-none d-md-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden-at-1k"
  }, renderConsultantTestimonials()));
};
var referralPanel = function referralPanel(referrer) {
  return /*#__PURE__*/React.createElement("div", {
    className: "left-panel"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "hero-header registration-welcome-title"
  }, referrer, ' ', "wants you to meet Clora."), /*#__PURE__*/React.createElement("div", {
    className: "body-text-1 registration-welcome-body"
  }, "Your friend,", ' ', referrer, ", thinks you are a great fit for Clora. Join the platform and find relevant projects based on your career interest and availability."), renderConsultantTestimonials());
};
var Registration = /*#__PURE__*/function (_Component) {
  function Registration(props) {
    var _this;
    _classCallCheck(this, Registration);
    _this = _callSuper(this, Registration, [props]);
    _this.state = {
      consultantView: props.consultantView,
      password: null
    };
    _this.toggleConsultantView = _this.toggleConsultantView.bind(_this);
    _this.toggleEmployerView = _this.toggleEmployerView.bind(_this);
    return _this;
  }
  _inherits(Registration, _Component);
  return _createClass(Registration, [{
    key: "toggleConsultantView",
    value: function toggleConsultantView() {
      this.setState({
        consultantView: true
      });
      analyticsTrack('Consultant Registration Form');
      window.history.pushState(null, 'Clora Consultant Registration', '/registration/new');
    }
  }, {
    key: "toggleEmployerView",
    value: function toggleEmployerView() {
      this.setState({
        consultantView: false
      });
      analyticsTrack('Employer Registration Form');
      window.history.pushState(null, 'Clora Employer Registration', '/registration/new?view=employer');
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      var errors = this.props.errors;
      if (errors) {
        return /*#__PURE__*/React.createElement("div", {
          className: "alert alert-danger",
          role: "alert"
        }, /*#__PURE__*/React.createElement("ul", null, Object.entries(errors).map(function (message) {
          return /*#__PURE__*/React.createElement("li", null, message[1]);
        })));
      }
      return null;
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      var consultantView = this.state.consultantView;
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        invitedEmail = _this$props.invitedEmail,
        company = _this$props.company,
        referrer = _this$props.referrer,
        referralToken = _this$props.referralToken,
        referrerCompany = _this$props.referrerCompany,
        signInUrl = _this$props.signInUrl,
        googleOmniauthUrl = _this$props.googleOmniauthUrl,
        msOmniauthUrl = _this$props.msOmniauthUrl;
      if (navigator.userAgent.indexOf('Chrome') !== -1) {
        document.body.className += ' chromium';
      }
      if (consultantView) {
        var withReferral = referrer && referralToken && !referrerCompany;
        var formWithErrors = /*#__PURE__*/React.createElement("div", {
          className: "form"
        }, this.renderErrors(), renderCopy(), /*#__PURE__*/React.createElement(ConsultantForm, {
          csrfToken: csrfToken,
          invitedEmail: invitedEmail,
          referralToken: referralToken,
          googleOmniauthUrl: googleOmniauthUrl,
          msOmniauthUrl: msOmniauthUrl,
          signInUrl: signInUrl
        }));
        var row = /*#__PURE__*/React.createElement(Row, {
          className: "consultant-registration"
        }, /*#__PURE__*/React.createElement(Col, {
          xs: true,
          sm: true
        }, withReferral ? referralPanel(referrer) : formWithErrors, !withReferral && /*#__PURE__*/React.createElement("div", {
          className: "d-block d-md-none"
        }, renderConsultantTestimonials())), /*#__PURE__*/React.createElement(Col, {
          xs: 12,
          sm: 6
        }, withReferral ? formWithErrors : consultantTestimonialsPanel()));
        return row;
      }
      return /*#__PURE__*/React.createElement("div", null, this.renderErrors(), /*#__PURE__*/React.createElement(EmployerSignupPanel, {
        csrfToken: csrfToken,
        invitedEmail: invitedEmail,
        company: company,
        referrer: referrer,
        referralToken: referralToken,
        referrerCompany: referrerCompany,
        signInUrl: signInUrl,
        googleOmniauthUrl: googleOmniauthUrl,
        msOmniauthUrl: msOmniauthUrl
      }), ' ');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var consultantView = this.state.consultantView;
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide"
      }, /*#__PURE__*/React.createElement("div", {
        className: "registration-tabs"
      }, /*#__PURE__*/React.createElement(Row, {
        className: "toggleView"
      }, /*#__PURE__*/React.createElement(Col, {
        xs: 6,
        sm: 3
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-center consultant-toggle selected-".concat(consultantView),
        role: "button",
        tabIndex: "0",
        onClick: function onClick() {
          return _this2.toggleConsultantView();
        }
      }, /*#__PURE__*/React.createElement("h2", null, "Consultant"))), /*#__PURE__*/React.createElement(Col, {
        xs: 6,
        sm: 3
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-center employer-toggle selected-".concat(!consultantView),
        role: "button",
        tabIndex: "-1",
        onClick: function onClick() {
          return _this2.toggleEmployerView();
        }
      }, /*#__PURE__*/React.createElement("h2", null, "Employer"))))), /*#__PURE__*/React.createElement("div", {
        className: "registration"
      }, this.renderForm()));
    }
  }]);
}(Component);
Registration.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  invitedEmail: PropTypes.string,
  company: PropTypes.string,
  consultantView: PropTypes.bool,
  referralToken: PropTypes.string,
  referrer: PropTypes.string,
  referrerCompany: PropTypes.string,
  errors: PropTypes.shape([]),
  signInUrl: PropTypes.string.isRequired,
  googleOmniauthUrl: PropTypes.string,
  msOmniauthUrl: PropTypes.string
};
Registration.defaultProps = {
  invitedEmail: null,
  company: null,
  consultantView: true,
  referralToken: null,
  referrer: null,
  referrerCompany: null,
  errors: null,
  googleOmniauthUrl: null,
  msOmniauthUrl: null
};
export default Registration;